import { get, post } from '@/api/request.js'
import { requestData } from '@/common/js/commont.js'

// 获取地区列表
export const getAreaList = data => post('/api/area/getAreaList', requestData(data))

// 获取用户设备接收参数
export const getDeviceParams = data => post('/api/device/getDeviceParams', requestData(data))

// 获取设备分钟值
export const getMinuteDeviceLogList = data => post('/api/Devicelog/getMinuteDeviceLogList', requestData(data))

